import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import ReactApexChart from "react-apexcharts";
import { useRef } from "react";


const PortInfoeWindow = (props) => {
  const { portInfo } = props;
  const styles = useStyles();
  const [graphData, setGraphData] = useState([]);
  const refOb = useRef(null)
  const [toolbarShow, setToolbarShow] = useState(true)

  let importData;
  let exportData
  useEffect(() => {
    if (portInfo?.dwell_history) {
       importData = portInfo?.dwell_history?.import_dwell.map((a) => {
        a.x = a.created_timestamp;
        a.y = a.import_dwell;
        return a;
      })

       exportData = portInfo?.dwell_history?.export_dwell.map((a) => {
        a.x = a.created_timestamp;
        a.y = a.export_dwell;
        return a;
      })
      setGraphData([{ name: "Import Dwell", data: importData }, { name: "Export Dwell", data: exportData }])
    }
  }, [])

  const options = {
    chart: {
      type: 'line',
      toolbar: {
        show: toolbarShow 
      },
    },
    colors: ['#1F78B4', '#A6CEE3'],
    markers: {
      size: 5,
    },
    stroke: {
      curve: 'smooth',
      width: 4,
      lineCap: 'round',
    },
    legend: {
      horizontalAlign: 'left',

    },
    zoom: {
      enabled: true,
      type: 'x',
      autoScaleYaxis: false,
    },
    xaxis: {
      type: 'datetime'
    },
    title: {
      text: "Dwell Time",
      align: "left",
      offsetY: 10,
      style: {
        fontSize:  '10px',
        fontWeight:  '500',
        color:  '#A3A3A3'
      },
    },
  };

  useEffect(() =>{
    if(refOb.current){
      const chart = refOb.current.chartRef
      const chartChild = chart.current.childNodes[0].childNodes
      Array.from(chartChild, item => {
        if(item.getAttribute('class') === 'apexcharts-toolbar'){
          const chartTools = item.childNodes
          Array.from(chartTools, subItem => {
            if(subItem.getAttribute('class') === 'apexcharts-zoomout-icon'){
              setTimeout(() =>{
                subItem.click()
                setToolbarShow(false)
              },100)
            }
          })
        }
      })
    }
  },[refOb.current])
  return (
    <React.Fragment>
      <Grid item xs={12} className={styles.portInfoWindow}>
        <Card className={styles.root}>
          <Typography className={styles.title} gutterBottom>
            Port of {portInfo.port_name}
          </Typography>
        </Card>
        <Grid container >
          <Grid item xs={6} sm={6}>
            <Typography className={styles.title2} color="textSecondary">
              Export Dwell
            </Typography>
            <Typography className={styles.textSmall}>
              {portInfo.export_dwell_time_stamp}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6}>
            <Typography className={styles.title2} color="textSecondary">
              Import Dwell
            </Typography>
            <Typography className={styles.textSmall}>
              {portInfo.import_dwell_time_stamp}
            </Typography>
          </Grid>
        </Grid>
        {
          graphData.length ?
            <>
              <Grid container className={styles.section1}>
                <ReactApexChart
                  ref={refOb}
                  options={options}
                  series={graphData}
                  width={'500'}
                  height={'300'}
                />
              </Grid>
            </> : null
        }
      </Grid>
    </React.Fragment>
  );
};

const useStyles = makeStyles(() => ({
  portInfoWindow: {
    "& Button": {
      backgroundColor: "#363740",
      color: "#FFFFFF",
      fontSize: 12,
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "500",
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "#363740",
    },
    "& .MuiCardActions-root": {
      padding: "0px 8px 8px 0px",
    },
    "& .MuiButton-root": {
      textTransform: "none",
    },
  },
  root: {
    borderRadius: "0px",
    width: 300,
    boxShadow: "none",
  },
  title: {
    fontSize: 16,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "bold",
    letterSpacing: "0.2px",
  },
  title2: {
    fontSize: 14,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "bold",
    letterSpacing: "0.2px",
    color: "rgb(80 80 80 / 74%)",
  },
  subTitle: {
    fontSize: 12,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "bold",
    letterSpacing: "0.2px",
  },
  pos: {
    fontSize: 16,
    fontFamily: "Inter",
    fontStyle: "normal",
    letterSpacing: "0.2px",
    fontWeight: "bold",
  },
  textSmall: {
    fontSize: 10,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "normal",
    letterSpacing: "0.2px",
    color: "black",
  },
  section1: {
    paddingTop: "8px",
  },
  btn: {
    backgroundColor: "#3B82F6 !important"
  },
  showRiskText: {
    color: "#000000",
    fontSize: "12px",
    fontWeight: "600",
    paddingTop: "8px"
  }
}));

export default PortInfoeWindow;
